<template>
  <div class="slds-size--medium">
    <!-- Label -->
    <label class="slds-form-element__label" for="select-01" v-if="label">
      {{ label }}
    </label>

    <div v-if="value && value.length" class="slds-listbox_selection-group selection-box">
      <ul class="slds-listbox slds-listbox_horizontal" role="listbox" aria-label="Selected Options:" aria-orientation="horizontal">
        <li class="slds-listbox-item" role="presentation" v-for="(range, index) in value" :key="index">
          <span class="slds-pill" role="option" :tabindex="index" aria-selected="true">
            <span class="slds-pill__label" :title="range" v-if="inputType === 'date'">{{range | formatDate($t('general.dateFormat'))}}</span>
            <span class="slds-pill__label" :title="range" v-else>{{range}}</span>
            <span class="slds-icon_container slds-pill__remove" title="Remove" @click="askForConfirmation(index)" v-if="!disabled && !(hideInput && localValue.length === 1)">
              <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                <use xlink:href="../../../assets/symbols.svg#close"></use>
              </svg>
            </span>
          </span>
        </li>
      </ul>
    </div>

    <div class="slds-form-element__control row" v-if="!hideInput">
      <input
        :class="valid ? '' : 'slds-has-error'"
        :disabled="disabled"
        :type="inputType"
        class="slds-input"
        v-model="text"
        @input="clearValidationError"
        @keyup.enter="addFilter" />

      <button class="slds-button slds-button_icon slds-is-selected slds-button_icon-border-filled slds-m-left--small" :disabled="disabled" :title="$t('general.add')" @click="addFilter">
        <svg class="slds-button__icon" aria-hidden="true">
          <use xlink:href="../../../assets/symbols.svg#add"></use>
        </svg>
        <span class="slds-assistive-text">{{ $t('general.add')}}</span>
      </button>
    </div>
    <div class="slds-form-element__help error" v-if="!valid">{{ error }}</div>

    <!-- Remove item confirmation modal -->
    <transition name="fade">
      <Modal
        v-if="showDeleteConfirmModal"
        :title="$t('campaignDesigner.targetDefinition.confirmFilterDisableTitle')"
        :neutral-button-text="$t('action.cancel')"
        :positive-button-text="$t('action.remove')"
        @close="closeModal"
        @neutralButtonClick="closeModal()"
        @positiveButtonClick="remove(selectedIndex)">

        <div class="slds-text-heading_small slds-text-align_center">
          {{$t('campaignDesigner.targetDefinition.confirmFilterDisableText')}}
        </div>

      </Modal>
    </transition>
  </div>
</template>
<script>
import Modal from '../../Modal'
import Validator from '../../../validation/Validator.vue'
export default {
  components: {
    Modal
  },
  mixins: [Validator],
  data () {
    return {
      localValue: [],
      selectedIndex: -1,
      showDeleteConfirmModal: false,
      text: ''
    }
  },
  methods: {
    addFilter () {
      this.clearValidationError()
      if (this.text && this.localValidate()) {
        this.localValue.push(this.text)
        this.text = ''
        this.$emit('input', this.localValue)
      }
    },
    askForConfirmation (option) {
      if (this.hideInput) {
        this.selectedIndex = option
        this.showDeleteConfirmModal = true
      } else {
        this.remove(option)
      }
    },
    closeModal () {
      this.selectedIndex = -1
      this.showDeleteConfirmModal = false
    },
    localValidate () {
      if (this.itemsValidation && this.itemsValidation.length) {
        this.itemsValidation.forEach(rule => {
          let re
          if (typeof rule === 'string') {
            switch (rule) {
              case 'year':
                re = /\d{4}/
                if (!re.test(this.text)) {
                  this.error = this.$t('validation.year')
                }
                break
            }
          } else {
            switch (rule.name) {
              case 'regex':
                re = rule.regex
                if (!re.test(this.text)) {
                  this.error = rule.message
                }
                break
            }
          }
        })
      }

      return !(this.error && this.error.length > 0)
    },
    remove (index) {
      this.localValue.splice(index, 1)
      this.$emit('input', this.localValue)
      this.closeModal()
    }
  },
  props: {
    disabled: Boolean,
    hideInput: Boolean,
    inputType: String,
    itemsValidation: Array,
    label: String,
    value: Array
  },
  created () {
    this.localValue = this.value
  }
}
</script>
<style lang="scss" scoped>
  button {
    height: auto;
  }
  .row {
    display: flex;
  }

  .selection-box {
    height: fit-content;
  }

  svg {
    cursor: pointer;
  }

  .error {
    color: #C23933
  }
</style>
